<mat-drawer-container>
  <mat-drawer mode="over" #drawer class="p-16" autoFocus="false">
    <div class="fx-column">
      <span class="text bold">{{'DOCUMENTS_LIST.FILTERS.LABEL' | translate}}</span>
      <span class="text">{{'DOCUMENTS_LIST.FILTERS.HINT' | translate}}</span>

      <app-document-approval-select label="{{'DOCUMENT.APPROVAL' | translate}}" [multiple]="true" [emitOnInit]="false"
        class="mt-20 fx-flex" (change)="onDocumentApprovalChange($event)" [(value)]="filters.approval"
        [noAutomatic]="true">
      </app-document-approval-select>

      <app-document-class-select label="{{'ENTITIES.DOCUMENT_TYPES' | translate}}" [multiple]="true" [search]="true"
        [emitOnInit]="false" class="mt-10 fx-flex" (change)="onDocumentClassChange($event)"
        [(value)]="filters.documentClass" [noAutomatic]="true">
      </app-document-class-select>

      <app-trademark-family-select label="{{'ENTITIES.TRADEMARK_FAMILIES' | translate}}" [multiple]="true"
        [search]="true" class="mt-10 fx-flex" (change)="onTrademarkFamilyChange($event)"
        [(value)]="filters.trademarkFamily" [emitOnInit]="false" *ngIf="!case">
      </app-trademark-family-select>

      <app-trademark-select label="{{'ENTITIES.TRADEMARKS' | translate}}" [multiple]="true" [search]="true"
        class="mt-10 fx-flex" (change)="onTrademarkChange($event)" [(value)]="filters.trademark" [emitOnInit]="false"
        *ngIf="!case">
      </app-trademark-select>

      <app-nice-select label="{{'ENTITIES.NICE_CLASSIFICATION' | translate}}" [multiple]="true" [search]="true"
        class="mt-10 fx-flex" [(value)]="filters.classNumber" (change)="onNiceClassificationChange($event)"
        [emitOnInit]="false" [restrict]="caseClasses">
      </app-nice-select>

      <app-product-service-select label="{{'ENTITIES.PRODUCTS_SERVICES' | translate}}" [multiple]="true" [search]="true"
        class="mt-10 fx-flex" [(value)]="filters.productsServices" (change)="onProductServiceChange($event)"
        [emitOnInit]="false" [trademarks]="case ? caseTrademarks : filters.trademark"
        [niceClassification]="filters.classNumber.length > 0 ? filters.classNumber : caseClasses">
      </app-product-service-select>

      <app-territory-select label="{{'ENTITIES.TERRITORIES' | translate}}" [multiple]="true" [search]="true"
        class="mt-10 fx-flex" [(value)]="filters.territories" (change)="onTerritoryChange($event)" [emitOnInit]="false"
        [restrict]="relevantTerritories" *ngIf="this.case?.type !== CaseType.RENEWAL_MAINTENANCE">
      </app-territory-select>

      <app-tag-select label="{{'ENTITIES.TAGS' | translate}}" [multiple]="true" [search]="true" class="mt-10 fx-flex"
        [(value)]="filters.tags" (change)="onTagChange($event)" [emitOnInit]="false">
      </app-tag-select>

      <app-select label="{{'DOCUMENT.CONFIDENTIALITY' | translate}}" [options]="confidentialOptions" [multiple]="false"
        class="mt-10 fx-flex" (change)="onConfidentialChange($event)" [emitOnInit]="false">
      </app-select>

      <app-daterangepicker label="{{'ENTITIES.PERIOD' | translate}}" [visuallyHiddenLabel]="true" [clearable]="true"
        placeholder="{{'ENTITIES.PERIOD' | translate}}" class="mt-10 fx-flex" (valueChange)="onPeriodChange($event)"
        [(value)]="filters.period">
      </app-daterangepicker>

      <button class="mt-20" [class.main-button]="filtersCount > 0" [class.button]="filtersCount === 0"
        (click)="closeDrawer()">
        {{(filtersCount > 0 ? 'ACTIONS.SEE_RESULTS' : 'ACTIONS.CLOSE') | translate}}
      </button>
    </div>
  </mat-drawer>

  <mat-drawer-content class="p-16">
    <div class="mb-16" *ngIf="uploadingBox">
      <app-uploading-documents-box class="mb-16"></app-uploading-documents-box>
    </div>

    <div class="fx-row fx-wrap">
      <div class="fx-row fw-wrap align-items-center justify-content-between fx-flex-100"
        *ngIf="displayMode !== 'hierarchy'">
        <div class="fx-row fw-wrap align-items-center justify-content-start">
          <button class="button" (click)="toggleDrawer()">
            <div class="fx-row align-items-center justify-content-start">
              {{'DOCUMENTS_LIST.FILTERS.LABEL' | translate}}
              <div class="badge ml-5 white" *ngIf="filtersCount > 0">
                {{filtersCount}}
              </div>
            </div>
          </button>
          <div class="ml-10 fx-row fx-wrap align-items-baseline justify-content-end">
            <app-animated-number [value]="count" [class]="'bold main'"></app-animated-number>
            <span class="text ml-5">
              <span class="bold main">{{((count > 1 ? entityKey + 'S' : entityKey) | translate).toLowerCase()}}</span>
              {{('UTILS.MATCHING' | translate).toLowerCase()}}
            </span>
          </div>

          <ng-content select="[slot=header]"></ng-content>

        </div>
        <app-input placeholder="{{'ACTIONS.SEARCH' | translate}}..." type="text" prefix="search"
          [(value)]="filters.query" (change)="onQueryChange($event)" class="ml-10">
        </app-input>
      </div>
    </div>

    <div class="fx-row fw-wrap align-items-center justify-content-start fx-flex-100"
      *ngIf="displayMode === 'hierarchy'">
      <app-select initial="none" label="{{'DOCUMENTS_HIERARCHY.LEVEL_1' | translate}}" [options]="level1Options"
        [multiple]="false" class="ml-10" [(value)]="levels[1]" (change)="onLevelChange(1, $event)" [emitOnInit]="false"
        style="width:180px;">
      </app-select>

      <app-select initial="none" label="{{'DOCUMENTS_HIERARCHY.LEVEL_2' | translate}}" [options]="level2Options"
        [multiple]="false" class="ml-10" [(value)]="levels[2]" (change)="onLevelChange(2, $event)" [emitOnInit]="false"
        style="width:180px;">
      </app-select>

      <app-select initial="none" label="{{'DOCUMENTS_HIERARCHY.LEVEL_3' | translate}}" [options]="level3Options"
        [multiple]="false" class="ml-10" [(value)]="levels[3]" (change)="onLevelChange(3, $event)" [emitOnInit]="false"
        style="width:180px;">
      </app-select>
    </div>

    <ng-content></ng-content>

  </mat-drawer-content>
</mat-drawer-container>
